export default "__VITE_ASSET__DTCAHgZh__"